import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header.js'
import Footer from '../Footer/Footer.js'
import { GoCircle } from 'react-icons/go'
import { SlLocationPin } from 'react-icons/sl'
import { Link, useLocation } from 'react-router-dom'
import PriceCalculator from '../DocumentShiping/priceCalculator.js'
import { MdContentCopy, MdDirectionsBike } from 'react-icons/md'
import Invoice from '../Common/Invoice.js'
import Accordion from '../Home/Accodion.js'
import { useMutation, useQuery } from '@apollo/client'
import { CANCEL_COURIER, GET_SINGLE_ORDER, UPDATE_ORDER } from '../graphql/Mutation/SameDayOrder.js'
import moment from 'moment'
import { toast } from 'react-toastify'
import { API_URL } from '../config.js'
import BikeCancelOrderUser from '../samedaycourier/BikeCancelOrderUser.js'
import { useModal } from '../Contex.js'


const SingleBikeOrder = () => {
    const { openModal } = useModal();
    const pollingIntervalRef = useRef(null); // Ref to track the interval
    const [lastApiCall, setLastApiCall] = useState(null);
    const lastStatusRef = useRef(null);
    const [orderData, setOrderData] = useState(null);
    const location = useLocation();
    const getId = location?.state?.id
    const [copySuccess, setCopySuccess] = useState(false);
    const [pollingInterval, setPollingInterval] = useState(null); // Store interval ID
    const [updateCourier] = useMutation(UPDATE_ORDER);
    const [shipmentData, setShipmentData] = useState();
    const mapRef = useRef(null); // Ref for the map container
    const mapInstance = useRef(null); // Store map instance for reuse
    const directionsRenderer = useRef(null); // Ref for the directions renderer
    // const [isOpen, setIsOpen] = useState(false);

    // const handleModalClose = () => {
    //     setIsOpen(false);
    // };

    // const handleModalOpen = () => {
    //     setIsOpen(true);
    // };
    const { data: GetOrderOrder, refetch } = useQuery(GET_SINGLE_ORDER, {
        variables: {
            getOrderforSameDayId: getId,
        },
        onCompleted: (fetchedData) => {
            // console.log('✌️fetchedData --->', fetchedData);
            const pickupDetails = fetchedData?.getOrderforSameDay?.data?.pickup_details?.address;
            const dropDetails = fetchedData?.getOrderforSameDay?.data?.drop_details?.address;

            if (pickupDetails && dropDetails) {
                setOrderData({
                    pickupLocation: { lat: pickupDetails?.lat, lng: pickupDetails?.lng },
                    dropLocation: { lat: dropDetails?.lat, lng: dropDetails?.lng },
                    status: fetchedData?.getOrderforSameDay?.data?.status || "open", // default to "open"
                });
            }
        },
    });
    // const { data: GetOrderOrder, refetch } = useQuery(GET_SINGLE_ORDER, {
    //     variables: {
    //         "getOrderforSameDayId": getId
    //     }
    // });
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    // const [cancelCourier] = useMutation(CANCEL_COURIER);
    // const cancelorder = () => {
    //     cancelCourier({ variables: { "orderId": GetOrderOrder?.getOrderforSameDay?.order_id } })
    //         .then(async ({ data }) => {
    //             refetch();
    //             toast.success("Order Cancelled successfully!", { autoClose: 2000 });

    //         })
    //         .catch((err) => {
    //             toast.error(err.message, { autoClose: 2000 });
    //         });
    // }

    const handleCopy = (awbNumber) => {
        // Use the Clipboard API to copy the text
        navigator.clipboard.writeText(awbNumber)
            .then(() => {
                setCopySuccess(true);
                setTimeout(() => {
                    setCopySuccess(false);
                }, 2000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };
    // useEffect(() => {
    //     const trackShipment = async () => {

    //         const order_id = GetOrderOrder?.getOrderforSameDay?.order_id;
    //         // const url = `https://pfe-apigw-uat.porter.in/v1/orders/${order_id}`;
    //         // const API_KEY = '8c18d7ac-38a8-4930-a020-149b0fdf45d5';
    //         try {
    //             if (GetOrderOrder?.getOrderforSameDay?.order_id) {
    //                 // const response = await fetch(url, {
    //                 //     method: 'GET',
    //                 //     headers: {
    //                 //         'Content-Type': 'application/json',
    //                 //         'X-API-KEY': API_KEY,
    //                 //     },
    //                 // });


    //                 // if (!response.ok) {
    //                 //     throw new Error('Network response was not ok');
    //                 // }
    //                 const response = await fetch(`${API_URL}/api/orders/${order_id}`);
    //                 if (!response.ok) {
    //                     throw new Error('Network response was not ok');
    //                 }
    //                 console.log('✌️response --->', response);
    //                 const data = await response.json();
    //                 console.log('✌️data++++', data);
    //                 setShipmentData(data);
    //                 if (['ended', 'cancelled'].includes(data?.status)) {
    //                     console.log(`Stopping API calls. Status: ${data?.status}`);
    //                     if (pollingInterval) {
    //                         clearInterval(pollingInterval);
    //                         setPollingInterval(null);
    //                     }
    //                 }

    //                 if (lastStatusRef.current !== data?.status) {
    //                     console.log(`Status changed from ${lastStatusRef.current} to ${data?.status}`);
    //                     lastStatusRef.current = data?.status; // Update the last known status

    //                     updateCourier({
    //                         variables: {
    //                             input: {
    //                                 status: data?.status,
    //                                 id: GetOrderOrder?.getOrderforSameDay?._id,
    //                             },
    //                         },
    //                     });
    //                 }

    //             }

    //         } catch (err) {
    //             console.log('✌️err --->', err);
    //         }
    //     };
    //     // Set up the interval
    //     if (!pollingInterval) {
    //         const interval = setInterval(trackShipment, 5000); // Call every 5 seconds
    //         setPollingInterval(interval);
    //     }

    //     // Cleanup function to clear the interval
    //     return () => {
    //         if (pollingInterval) {
    //             clearInterval(pollingInterval);
    //             setPollingInterval(null);
    //         }
    //     };
    //     // trackShipment();
    // }, [GetOrderOrder?.getOrderforSameDay?.order_id, pollingInterval])
    useEffect(() => {

        let requestInProgress = false; // Flag to prevent overlapping calls

        const trackShipment = async () => {
            if (requestInProgress) {
                // console.log('Request skipped to avoid overlap.');
                return;
            }

            requestInProgress = true;

            try {
                const order_id = GetOrderOrder?.getOrderforSameDay?.order_id;
                if (!order_id) return;

                const response = await fetch(`${API_URL}/api/orders/${order_id}`);
                if (!response.ok) {
                    if (response.status === 429) {
                        console.warn('Rate limit reached. Skipping this cycle.');
                        return;
                    }
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                // console.log('✌️data++++', data);

                if (data?.status) {
                    setShipmentData(data);
                }

                // Stop polling if the status is `ended` or `cancelled`
                if (['ended', 'cancelled'].includes(data?.status) && GetOrderOrder?.getOrderforSameDay?.status === 'pending') {
                    // console.log(`Stopping API calls. Status: ${data?.status}`);
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                    return;
                }

                // Update the status if it has changed
                if (lastStatusRef.current !== data?.status) {
                    lastStatusRef.current = data?.status;

                    await updateCourier({
                        variables: {
                            input: {
                                status: data?.status,
                                id: GetOrderOrder?.getOrderforSameDay?.id,
                                pymentOrder: false,
                            },
                        },
                    });
                }
            } catch (err) {
                // console.log('✌️err --->', err);
            } finally {
                requestInProgress = false; // Reset flag
            }
        };

        if (!pollingIntervalRef.current && GetOrderOrder?.getOrderforSameDay?.order_id) {
            pollingIntervalRef.current = setInterval(trackShipment, 60000); // Call every 1 minute
        }

        return () => {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
            }
        };
    }, [GetOrderOrder?.getOrderforSameDay?.order_id]);


    useEffect(() => {
        const initMap = async () => {
            const google = await loadGoogleMapsScript("AIzaSyDpEuwbvnz8Aokf6wuwNBBi9kilDW6AJQA");

            if (mapRef.current && orderData?.pickupLocation) {
                mapInstance.current = new google.maps.Map(mapRef.current, {
                    zoom: 12,
                    center: orderData?.pickupLocation,
                });

                directionsRenderer.current = new google.maps.DirectionsRenderer();
                directionsRenderer.current.setMap(mapInstance.current);

                addMarkers(orderData);
                showRoute(orderData?.pickupLocation, orderData?.dropLocation);
            }
        };

        if (orderData?.pickupLocation) {
            initMap();
        }
    }, [orderData]);

    const showRoute = (pickup, drop) => {
        const google = window.google;
        const directionsService = new google.maps.DirectionsService();

        const request = {
            origin: pickup,
            destination: drop,
            travelMode: google.maps.TravelMode.DRIVING, // Use WALKING or BICYCLING if needed
        };

        directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
                directionsRenderer.current.setDirections(result);
            } else {
                console.error("Directions request failed due to " + status);
            }
        });
    };

    const addMarkers = (data) => {
        mapInstance.current.markers?.forEach((marker) => marker.setMap(null));
        mapInstance.current.markers = [];

        const pickupMarker = new window.google.maps.Marker({
            position: data?.pickupLocation,
            map: mapInstance.current,
            title: "Pickup Location",
        });
        mapInstance.current.markers.push(pickupMarker);

        const dropMarker = new window.google.maps.Marker({
            position: data?.dropLocation,
            map: mapInstance.current,
            title: "Drop Location",
        });
        mapInstance.current.markers.push(dropMarker);

        if (data?.status === "live" && data?.liveLocation) {
            const liveMarker = new window.google.maps.Marker({
                position: data.liveLocation,
                map: mapInstance.current,
                title: "Driver's Live Location",
                icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            });

            const infoWindow = new window.google.maps.InfoWindow({
                content: `<p>Status: ${data?.status}</p>`,
            });

            liveMarker.addListener("mouseover", () => infoWindow.open(mapInstance.current, liveMarker));
            liveMarker.addListener("mouseout", () => infoWindow.close());

            mapInstance.current.markers.push(liveMarker);
        }
    };

    // Logic for handling the status of the order (open, accepted, live, ended, cancelled)
    const getStatusText = (status) => {
        switch (status) {
            case "live":
                return "Order is live and in transit.";
            case "accepted":
                return "Order has been accepted.";
            case "ended":
                return "Order has been completed.";
            case "cancelled":
                return "Order has been cancelled.";
            case "open":
            default:
                return "Order is open and awaiting action.";
        }
    };
    // useEffect(() => {
    //     const center = { lat: 19.074820158286663, lng: 72.88340888062348 }; // Default center
    //     if (window.google && mapRef.current) {
    //         mapInstance.current = new window.google.maps.Map(mapRef.current, {
    //             zoom: 12,
    //             center
    //         });

    //         addMarkers(orderData);
    //     }
    // }, [orderData]);
    const loadGoogleMapsScript = (apiKey) => {
        return new Promise((resolve, reject) => {
            if (window.google) {
                resolve(window.google);
                return;
            }

            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(window.google);
            script.onerror = (err) => reject(err);

            document.body.appendChild(script);
        });
    };

    // useEffect(() => {
    //     const initMap = async () => {
    //         try {
    //             const google = await loadGoogleMapsScript("AIzaSyDpEuwbvnz8Aokf6wuwNBBi9kilDW6AJQA");

    //             if (mapRef.current && orderData?.pickupLocation) {
    //                 mapInstance.current = new google.maps.Map(mapRef.current, {
    //                     zoom: 12,
    //                     center: orderData?.pickupLocation,
    //                 });

    //                 addMarkers(orderData);
    //             }
    //         } catch (error) {
    //             console.error("Failed to load Google Maps API:", error);
    //         }
    //     };

    //     initMap();
    // }, [orderData]);

    // const addMarkers = (data) => {
    //     mapInstance.current.markers?.forEach((marker) => marker.setMap(null));
    //     mapInstance.current.markers = [];

    //     const pickupMarker = new window.google.maps.Marker({
    //         position: data?.pickupLocation,
    //         map: mapInstance.current,
    //         title: "Pickup Location",
    //     });
    //     mapInstance.current.markers.push(pickupMarker);

    //     const dropMarker = new window.google.maps.Marker({
    //         position: data?.dropLocation,
    //         map: mapInstance.current,
    //         title: "Drop Location",
    //     });
    //     mapInstance.current.markers.push(dropMarker);

    //     if (data?.status === "live" && data?.liveLocation) {
    //         const liveMarker = new window.google.maps.Marker({
    //             position: data.liveLocation,
    //             map: mapInstance.current,
    //             title: "Driver's Live Location",
    //             icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
    //         });

    //         const infoWindow = new window.google.maps.InfoWindow({
    //             content: `<p>Status: ${data?.status}</p>`,
    //         });

    //         liveMarker.addListener("mouseover", () => infoWindow.open(mapInstance.current, liveMarker));
    //         liveMarker.addListener("mouseout", () => infoWindow.close());

    //         mapInstance.current.markers.push(liveMarker);
    //     }
    // };

    return (
        <div>
            <div className='bg-gray-0'>
                <Header />
                <div className='mx-auto md:pt-7 pt-9 pb-9 max-w-auto lg:px-8'>
                    <div className='border border-gray-300 p-2 rounded-md md:space-y-6 space-y-9'>
                        <div className='px-4 mt-4'>
                            {/* <p className='text-2xl mt-4 font-bold'>Track Courier Details</p> */}
                            <div className={`text-md flex mt-1 font-semibold ${GetOrderOrder?.getOrderforSameDay?.trackStatus === 'Shipment Cancelled' ?  'text-red-600' :'text-green-600' } `}>
                                <MdDirectionsBike className='text-2xl me-3 drop-shadow-xl' />
                                <h1 className='font-semibold'>In-City Bike Parcel Delivery Services</h1>
                            </div>
                            <p className={`text-md mt-1 font-semibold ${GetOrderOrder?.getOrderforSameDay?.trackStatus === 'Shipment Cancelled' ?  'text-red-600' :'text-green-600' } `}>
                                {GetOrderOrder?.getOrderforSameDay?.trackStatus}
                            </p>
                        </div>
                        <div className='flex flex-wrap justify-between px-4'>
                            <div className='space-y-2'>
                                {GetOrderOrder?.getOrderforSameDay?.cfOrderId && <p className='text-sm font-semibold text-gray-500'> CF Shipment ID <span>{GetOrderOrder?.getOrderforSameDay?.cfOrderId}</span></p>}
                                {GetOrderOrder?.getOrderforSameDay?.request_id && <p className='text-sm font-semibold text-gray-500'>Request No. <span>{GetOrderOrder?.getOrderforSameDay?.request_id}</span></p>}
                                {GetOrderOrder?.getOrderforSameDay?.order_id && <p className='text-sm flex font-semibold text-slate-900'>AWB NO. <span className='ms-1'>{GetOrderOrder?.getOrderforSameDay?.order_id}</span>


                                    <MdContentCopy
                                        onClick={() => { handleCopy(GetOrderOrder?.getOrderforSameDay?.order_id) }}
                                        className="ml-1.5 text-lg cursor-pointer text-blue-500"
                                    >
                                    </MdContentCopy>
                                </p>}
                                {copySuccess && (
                                    <p className="text-green-500 text-sm">Copied to clipboard!</p>
                                )}
                                <p className='text-sm text-gray-500'>{moment(GetOrderOrder?.getOrderforSameDay?.createdAt).format('DD/MM/YYYY')}</p>
                            </div>
                            <div className='md:space-x-4 space-y-4 md:mt-7 lg:mt-0'>
                                <Link to="/accordionhelp">
                                    <button
                                        className='px-9 py-1 mr-4 md:mr-0 rounded-md bg-slate-900 text-white'
                                    >
                                        Help
                                    </button>
                                </Link>
                                {/* {GetOrderOrder?.getOrder?.awb_number && GetOrderOrder?.getOrder?.trackStatus === 'Shipment Cancelled' && activeButton === 'All Courier' && */}
                                {/* <button
                                    // onClick={() => {
                                    //     handleDownload(GetOrderOrder?.
                                    //         getOrder
                                    //         ?.label)
                                    // }}
                                    className='px-3 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white'
                                >
                                    Download Label
                                </button> */}
                                {/* }
                                {GetOrderOrder?.getOrder?.awb_number && GetOrderOrder?.getOrder?.trackStatus === 'Shipment Cancelled' && */}

                                {/* <button
                                    className='px-3 py-1 mr-4 md:mr-0 rounded-md bg-slate-900 text-white'
                                // onClick={handleDownloadInvoice}
                                >
                                    Download Invoice
                                </button> */}
                                {/* }
                                {(shipmentData?.data && shipmentData?.data?.status !== "in transit" && shipmentData?.data?.status !== "delivered" && shipmentData?.data?.status !== "out for delivery")
                                    && GetOrderOrder?.getOrder?.awb_number && GetOrderOrder?.getOrder?.trackStatus === 'Shipment Cancelled' && activeButton === 'All Courier' ? */}

                                {GetOrderOrder?.getOrderforSameDay?.status !== 'cancelled' && GetOrderOrder?.getOrderforSameDay?.status !== 'live' && GetOrderOrder?.getOrderforSameDay?.status !== 'open' && GetOrderOrder?.getOrderforSameDay?.status !== 'ended' && (
                                    <button
                                        className="px-3 py-1 rounded-md border border-red-500 text-red-500"
                                        // onClick={() => {
                                        //     // cancelorder(GetOrderOrder?.getOrderforSameDay?.order_id);
                                        //     // handleModalOpen(); // Open the modal after canceling the order
                                        // }}
                                        onClick={() => openModal(GetOrderOrder?.getOrderforSameDay?.order_id, getId, "SingleBikeOrder")}
                                    >
                                        Cancel Shipment
                                    </button>
                                )}

                                {/* Modal opens when isOpen is true
                                // {isOpen && (
                                //     <BikeCancelOrderUser
                                //         isOpen={isOpen}
                                //         handleModalClose={handleModalClose}
                                //         cancelorder={cancelorder}

                                //     />
                                // )} */}


                                {/* {GetOrderOrder?.getOrderforSameDay?.status !== 'cancelled' && 
                                <button
                                    className='px-3 py-1 rounded-md border border-red-500 text-red-500'
                                    onClick={() => { cancelorder(GetOrderOrder?.getOrderforSameDay?.order_id) }}
                                >
                                    Cancel Shipment
                                </button> */}

                                {/* } */}
                                {/* } */}
                                {/* <button
                                    className='px-3 py-1 rounded-md border border-red-500 text-red-500'
                                    onClick={() => openModal(GetOrderOrder?.getOrder?.awb_number, getId)}
                                >
                                    Cancel Shipment
                                </button> */}
                            </div>
                        </div>
                        <div className='grid gap-x-3 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-3'>
                            <div className='space-y-4 p-5 border border-gray-300 rounded-md'>
                                <p className='text-md font-semibold'>Address Details</p>
                                <div className='flex space-x-4'>
                                    <div className='space-y-1 text-gray-400'>
                                        <GoCircle />
                                        <ul className='ms-1.5'>
                                            {[...Array(8)].map((_, i) => (
                                                <li key={i} className={`text-xs leading-3 ${i >= 7 ? 'sm:hidden' : ''}`}>I</li>
                                            ))}
                                        </ul>
                                        <SlLocationPin />
                                    </div>
                                    <div className='space-y-4 w-full  text-ellipsis overflow-hidden'>
                                        <div>
                                            <p className='text-sm font-semibold mb-1'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.contact_details?.name}
                                                <span className='ms-1 text-gray-600'>(Pickup)</span>
                                            </p>
                                            <p className='text-sm truncate'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.street_address1}
                                                {/* <p className='text-sm truncate'>surat. gujrat - 7890789</p> */}
                                            </p>
                                            <p className='text-sm text-gray-500 truncate'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.pickup_details?.address?.contact_details?.phone_number}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='text-sm font-semibold mb-1'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.contact_details?.name}
                                                <span className='ms-1 text-gray-600'>(Delivery)</span>
                                            </p>
                                            <p className='text-sm truncate'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.street_address1}
                                                {/* <p className='text-sm truncate'> surat. gujrat - 679887</p> */}
                                            </p>
                                            <p className='text-sm text-gray-500 truncate'>
                                                {GetOrderOrder?.getOrderforSameDay?.data?.drop_details?.address?.contact_details?.phone_number}
                                            </p>
                                        </div>
                                    </div>

                                </div>

                                {/* <p className="text-md font-semibold mb-4">Package Details</p>
                                <div className='flex justify-between'>
                                    <p className='text-sm font-semibold text-gray-500'>Weight (Kg)</p>
                                    <p className='text-sm font-semibold'>12 Kg</p>
                                </div>
                                <div className='flex justify-between'>
                                    <p className='text-sm font-semibold text-gray-500'>Product Category</p>
                                    <p className='text-sm font-semibold'>sedhfjgkhldf</p>
                                </div>
                                <div className='flex justify-between'>
                                    <p className='text-sm font-semibold text-gray-500'>Product Value</p>
                                    <p className='text-sm font-semibold'>₹1200</p>
                                </div> */}
                                {/* <div>
                                    {shipmentData && (
                                        <div>
                                            {shipmentData.order_id && <h3>Order ID: {shipmentData.order_id}</h3>}
                                            {shipmentData.status && <p>Status: {shipmentData.status}</p>}
                                            {shipmentData.partner_info?.name && <p>Partner: {shipmentData.partner_info?.name || 'N/A'}</p>}
                                            {shipmentData.partner_info?.vehicle_number && <p>Vehicle: {shipmentData.partner_info?.vehicle_number || 'N/A'}</p>}
                                            {shipmentData.partner_info?.mobile?.mobile_number && <p>Mobile No: {shipmentData.partner_info?.mobile?.mobile_number || 'N/A'}</p>}
                                        </div>
                                    )}
                                </div> */}
                                <div className='mt-4'>
                                    {GetOrderOrder?.getOrderforSameDay?.driverInfo && (
                                        <div className='p-5 border border-slate-300 rounded-lg'>
                                            <p className='text-md font-semibold pb-4'>Tracking Information</p>
                                            <div className='space-y-2'>

                                                {/* <div className='border-t pt-3 space-y-3 '>
                                                    <div className='text-sm space-y-2 font-semibold text-slate-600'>
                                                        {GetOrderOrder?.getOrderforSameDay?.order_id && <h3>Order ID: {GetOrderOrder?.getOrderforSameDay?.order_id}</h3>}
                                                        {GetOrderOrder?.getOrderforSameDay?.status && <p>Status: {GetOrderOrder?.getOrderforSameDay?.status}</p>}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo && <p>Delivery Partner Mobile No:{GetOrderOrder?.getOrderforSameDay?.driverInfo?.mobile?.mobile_number}</p>}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.name && <p>Partner: {GetOrderOrder?.getOrderforSameDay?.driverInfo?.name || 'N/A'}</p>}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number && <p>Vehicle: {GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number || 'N/A'}</p>}
                                                    </div>
                                                </div> */}
                                                <div className="border-t pt-3 space-y-3">
                                                    <div className="text-sm space-y-2 text-slate-600">
                                                        {/* Order ID */}
                                                        {GetOrderOrder?.getOrderforSameDay?.order_id && (
                                                            <p>
                                                                Order ID: <span className="font-semibold text-slate-800">{GetOrderOrder?.getOrderforSameDay?.order_id}</span>
                                                            </p>
                                                        )}

                                                        {/* Status */}
                                                        {GetOrderOrder?.getOrderforSameDay?.status && (
                                                            <p>
                                                                Status: <span className="font-semibold text-slate-800">{GetOrderOrder?.getOrderforSameDay?.status}</span>
                                                            </p>
                                                        )}

                                                        {/* Delivery Partner Mobile Number */}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.mobile?.mobile_number && (
                                                            <p>
                                                                Delivery Partner Mobile No:{" "}
                                                                <span className="font-semibold text-slate-800">{GetOrderOrder?.getOrderforSameDay?.driverInfo?.mobile?.mobile_number}</span>
                                                            </p>
                                                        )}

                                                        {/* Partner Name */}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.name && (
                                                            <p>
                                                                Partner: <span className="font-semibold text-slate-800">{GetOrderOrder?.getOrderforSameDay?.driverInfo?.name || "N/A"}</span>
                                                            </p>
                                                        )}

                                                        {/* Vehicle Number */}
                                                        {GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number && (
                                                            <p>
                                                                Vehicle: <span className="font-semibold text-slate-800">{GetOrderOrder?.getOrderforSameDay?.driverInfo?.vehicle_number || "N/A"}</span>
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )}

                                </div>


                            </div>

                            {/* {shipmentData && ( */}
                            <div className="w-full mx-auto p-5 border border-gray-300 rounded-md bg-white">
                                <p className="text-md font-semibold mb-4">Shipment Tracking</p>

                                <div ref={mapRef} style={{ height: "500px", width: "100%" }}>   <div>
                                    <p>Status: {getStatusText(orderData?.status)}</p>
                                </div></div>
                                {/* <img src={maps01} alt="" className='rounded-xl ' style={{ width: '100%', height: '300px' }} /> */}
                                {/* <div className="relative flex flex-col items-start space-y-8">
                                        {statusOrder.map((status, index) => {
                                            const isCancelled = shipmentData?.data?.status === "cancelled";
                                            const rto = shipmentData?.data?.status === "rto";

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="flex items-center space-x-4">
                                                        <div className="relative">
                                                            <div
                                                                ref={(el) => iconRefs.current[index] = el}
                                                                className={`${getIconColor(shipmentData?.data?.history, status, isCancelled, rto)} ${shipmentData?.data?.status === "pending pickup" && status === 'PP' ? 'bg-green-500 border-green-200' : ''} border-4 text-white p-1.5 rounded-full`}
                                                            >
                                                                {status === 'PP' && <BsBoxSeam />}
                                                                {status === 'IT' && <LiaTruckMovingSolid />}
                                                                {status === 'OFD' && <MdDirectionsBike />}
                                                                {status === 'DL' && <FaRegCheckCircle />}
                                                                {status === 'CL' && isCancelled && <SlClose />}
                                                                {status === 'RT' && rto && <SlClose />}
                                                            </div>
                                                            {index < statusOrder.length - 1 && (
                                                                <div
                                                                    style={{ height: `${lineHeights[index]}px` }}
                                                                    className={`${getLineColor(shipmentData?.data?.history, statusOrder[index + 1], isCancelled, rto)} absolute left-1/2 transform -translate-x-1/2 w-px`}
                                                                />
                                                            )}
                                                        </div>
                                                        <div>
                                                            <h2 className="font-medium text-sm">{getStatus(status)}</h2>
                                                            <p className="text-sm text-gray-500">
                                                                {shipmentData?.data?.history.find(hist => hist.status_code === status)?.event_time || ''}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {!isCancelled && showMore && shipmentData?.data?.history
                                                        .filter(hist => hist.status_code === status)
                                                        .reverse()
                                                        .map((hist, histIndex) => (
                                                            <div key={histIndex} className="flex items-start ml-8 space-x-4">
                                                                <div className="w-px bg-slate-300" style={{ height: 'auto' }}></div>
                                                                <div>
                                                                    <p className="text-sm font-semibold">{hist.event_time}</p>
                                                                    <p className="text-sm text-gray-500">{hist.location}</p>
                                                                    <p className="text-sm text-gray-500">{hist.message}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                    <button onClick={handleToggle} className="mt-7 text-black ml-7 flex font-semibold text-sm focus:outline-none">
                                        {showMore ? 'SHOW LESS' : 'SHOW MORE'} <span className='self-center text-xl'>{showMore ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}</span>
                                    </button> */}
                            </div>
                            {/* )} */}

                            <div className='p-5 border border-gray-300 rounded-md'>
                                <PriceCalculator orderAmount={Math.round(GetOrderOrder?.getOrderforSameDay?.order_amount)} />
                            </div>
                        </div>
                        {/* <div id="hidden-invoice-container" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                            <Invoice />
                        </div> */}
                    </div>
                </div>
                <Accordion />
                <div className='mt-16'>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default SingleBikeOrder
